import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import {
  PaymentCartService,
  VerifyRequestPaymentCartService,
} from "../../services/MainScreen";
import { getAmoutFromCookie } from "../../utility/Cookies";
import { HOME_URL_LOCAL } from "../../utility/BaseUrl";

const Payment = ({ user }) => {
  const [searchParams] = useSearchParams();
  const [resultPayment, setResultPayment] = useState(null);

  useEffect(() => {
    if (user.id > 0) {
      const authority = searchParams.get("Authority");
      const status = searchParams.get("Status");

      async function VerifyRequestPaymentCart() {
        const res = await VerifyRequestPaymentCartService(
          getAmoutFromCookie(),
          authority
        );
        debugger;
        if (res.status === 200) {
          var paymentCart = await PaymentCartService(res.result.RefID, user);
        }
        setResultPayment(res);
      }
      
      if (status === "OK") VerifyRequestPaymentCart();
      else if (status === "NOK")   setResultPayment({
        status: 400,
        message: "پرداخت ناموفق بود.",
        result: { status: false },
      });
      else
        setResultPayment({
          status: 400,
          message: "پرداخت ناموفق بود. لطفاً دوباره تلاش کنید.",
          result: { status: false },
        });
    }
  }, [searchParams, user.id]);

  const renderPaymentResult = () => {
    if (resultPayment)
      return (
        <div className="text-center">
          <h1
            style={{
              marginTop: "28px;",
            }}
          >
            {resultPayment.status === 200
              ? "موفق"
              : resultPayment.status === 400
              ? "خطا"
              : ""}
          </h1>
          <p style={{ fontSize: "1.3rem;" }}> {resultPayment.message} </p>
        </div>
      );
      else
      return (
        <div className="text-center">
           <i className="fa fa-refresh fa-spin fa-fw" />
           کمی صبر کنید...
        </div>
      );
  };

  return (
    <div className="payment">
      {renderPaymentResult()}
      <a href={HOME_URL_LOCAL} className="btn btn-primary">
        بازگشت
      </a>
    </div>
  );
};

export default Payment;
